export const initialState = {
    house: {},
};
